// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lp-success {
	padding: 1.25rem;
	background: #f0fdf4;
	border: 1px solid #bbf7d0;
	border-radius: 0.375rem;
}

/* Segmented recovery-method picker — Email | Text message */
.lp-method-tabs {
	background: #f3f4f6;
	border-radius: 0.5rem;
	padding: 0.25rem;
	gap: 0.25rem;
}

.lp-method-tabs .nav-link {
	font-size: 0.82rem;
	font-weight: 600;
	color: #4b5563;
	background: transparent;
	border: none;
	border-radius: 0.375rem;
	padding: 0.45rem 0.75rem;
}

.lp-method-tabs .nav-link:hover {
	color: rgb(0, 51, 51);
}

.lp-method-tabs .nav-link.active {
	background: #fff;
	color: rgb(0, 51, 51);
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* Account picker — clean record list, no Bootstrap list-group baggage */
.lp-account-list {
	display: flex;
	flex-direction: column;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	overflow: hidden;
}

.lp-account-item {
	background: #fff;
	border: none;
	border-top: 1px solid #f3f4f6;
	padding: 0.85rem 1rem;
	font-size: 0.92rem;
	font-weight: 500;
	color: rgb(0, 51, 51);
	text-align: left;
	font-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace;
	letter-spacing: 0.02em;
	cursor: pointer;
}

.lp-account-item:first-child {
	border-top: none;
}

.lp-account-item:hover:not(:disabled) {
	background: #f9fafb;
}

.lp-account-item:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/lost-password/lost-password.component.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA,4DAA4D;AAC5D;CACC,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,YAAY;CACZ,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,yCAAyC;AAC1C;;AAEA,wEAAwE;AACxE;CACC,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,6BAA6B;CAC7B,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,gBAAgB;CAChB,qEAAqE;CACrE,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB","sourcesContent":[".lp-success {\n\tpadding: 1.25rem;\n\tbackground: #f0fdf4;\n\tborder: 1px solid #bbf7d0;\n\tborder-radius: 0.375rem;\n}\n\n/* Segmented recovery-method picker — Email | Text message */\n.lp-method-tabs {\n\tbackground: #f3f4f6;\n\tborder-radius: 0.5rem;\n\tpadding: 0.25rem;\n\tgap: 0.25rem;\n}\n\n.lp-method-tabs .nav-link {\n\tfont-size: 0.82rem;\n\tfont-weight: 600;\n\tcolor: #4b5563;\n\tbackground: transparent;\n\tborder: none;\n\tborder-radius: 0.375rem;\n\tpadding: 0.45rem 0.75rem;\n}\n\n.lp-method-tabs .nav-link:hover {\n\tcolor: rgb(0, 51, 51);\n}\n\n.lp-method-tabs .nav-link.active {\n\tbackground: #fff;\n\tcolor: rgb(0, 51, 51);\n\tbox-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n/* Account picker — clean record list, no Bootstrap list-group baggage */\n.lp-account-list {\n\tdisplay: flex;\n\tflex-direction: column;\n\tborder: 1px solid #e5e7eb;\n\tborder-radius: 0.5rem;\n\toverflow: hidden;\n}\n\n.lp-account-item {\n\tbackground: #fff;\n\tborder: none;\n\tborder-top: 1px solid #f3f4f6;\n\tpadding: 0.85rem 1rem;\n\tfont-size: 0.92rem;\n\tfont-weight: 500;\n\tcolor: rgb(0, 51, 51);\n\ttext-align: left;\n\tfont-family: 'IBM Plex Mono', ui-monospace, SFMono-Regular, monospace;\n\tletter-spacing: 0.02em;\n\tcursor: pointer;\n}\n\n.lp-account-item:first-child {\n\tborder-top: none;\n}\n\n.lp-account-item:hover:not(:disabled) {\n\tbackground: #f9fafb;\n}\n\n.lp-account-item:disabled {\n\topacity: 0.6;\n\tcursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
